import * as React from 'react';
import { joinClasses } from '../../../Utils/className.util';
// @ts-ignore
import styles from './HStack.module.scss';

interface HStackProps {
	children: React.ReactElement | React.ReactElement[];
	alignCenter?: boolean;
	space?: number;
}

const HStack: React.FC<HStackProps> = props => {
	const { children, space, alignCenter } = props;

	return (
		<div
			className={joinClasses([
				styles.container,
				alignCenter ? styles.alignCenter : undefined,
			])}>
			{React.Children.map(children, (child, index) => {
				return <div className={styles.item}>{child}</div>;
			})}
		</div>
	);
};

export default HStack;
